import React from "react"
import classNames from "classnames"

import styles from "./index.module.less"

const Input: React.FC<React.InputHTMLAttributes<HTMLInputElement>> = (
    props
) => {
    const { className, ...inputProps } = props

    return (
        <div className={classNames(styles.inputWrapper, className)}>
            <input className={styles.input} {...inputProps} />
        </div>
    )
}
export default Input
